<div id="calendar" class="page-layout simple fullwidth" eguardPerfectScrollbar>
  <mat-progress-bar *ngIf="isLoading" class="my-color" mode="query" value="value" [bufferValue]="bufferValue">
  </mat-progress-bar>
  <!-- HEADER -->
  <div class="header p-16 p-sm-24 thin-header" style="background-color: white !important; color: #069bde !important;">

    <div class="header-content" fxLayout="column" fxLayoutAlign="space-between">

      <div class="header-top" fxLayout="row" fxLayoutAlign="space-between center" fxLayout.xs="column">

        <div class="logo mb-16 mb-sm-0" fxLayout="row" fxLayoutAlign="start center">

          <!-- <mat-icon class="logo-icon" *eguardIfOnDom [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">today
          </mat-icon>

          <span class="logo-text" *eguardIfOnDom
            [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">Calendar</span> -->

          <button mat-raised-button color="accent" class="create" (click)='addEvent("event")'>
            <mat-icon>add</mat-icon>
            CREATE
          </button>
        </div>

        <!-- TOOLBAR -->

        <div class="toolbar" fxLayout="row" fxLayoutAlign="start center" style="padding-right: 20px;">
          <button mat-button class="mat-icon-button" matTooltip="Today" style="color: #069bde !important;"
            matTooltipPosition="above" mwlCalendarToday [(viewDate)]="viewDate"
            (viewDateChange)="selectedDay = {date:$event}" aria-label="Today" mat-tooltip="Today"
            (click)="view = 'day'">
            <mat-icon style="color: #069bde !important;">today</mat-icon>
          </button>
          <mat-form-field>
            <mat-select class="selectView" [(ngModel)]="view" style="color: #069bde !important;">
              <mat-option value='month' aria-label="Month">Month View</mat-option>
              <mat-option value='week' aria-label="Week" selected>Week View</mat-option>
              <mat-option value='day' aria-label="Day">Day View</mat-option>
            </mat-select>
          </mat-form-field>


        </div>
      </div>
      <!-- / TOOLBAR -->

      <!-- HEADER BOTTOM -->
      <div class="header-bottom" fxLayout="row" fxLayoutAlign="center center" *eguardIfOnDom
        [@animate]="{value:'*',params:{delay:'150ms'}}" style="margin-top: 0px;">

        <button mat-button class="mat-icon-button arrow" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
          (viewDateChange)="changeTimeFrame($event)" aria-label="Previous">
          <mat-icon style="color: #069bde !important;">chevron_left</mat-icon>
        </button>

        <div class="title">
          {{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}
        </div>

        <button mat-button class="mat-icon-button arrow" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
          (viewDateChange)="changeTimeFrame($event)" aria-label="Next">
          <mat-icon style="color: #069bde !important;">chevron_right</mat-icon>
        </button>

      </div>
      <!-- ADD EVENT BUTTON -->
      <!-- <div>
        <ngc-float-button icon="add" class="add-calender-button mat-warn" aria-label="Add event" color="#F44336"
          direction="bottom" [disabled]="isLoading">
          <ngc-float-item-button icon="event" content="Add Event" (click)='addEvent("event")' color="#595858">
          </ngc-float-item-button>
        </ngc-float-button>
      </div> -->

      <!-- / HEADER BOTTOM -->
    </div>


  </div>
  <!-- / HEADER -->

  <!-- CONTENT -->
  <div class="row">
    <div class="side-pane">
      <mat-calendar mat-mode="month" [selected]="viewDate" (selectedChange)="onSelect($event)">
      </mat-calendar>
      <br>
      <mat-divider *ngIf="(role.toLowerCase() == 'clerk' || role.toLowerCase() == 'judge')"></mat-divider>

      <mat-toolbar class="organization" *ngIf="(role.toLowerCase() == 'clerk' || role.toLowerCase() == 'judge')">
        <mat-icon (click)="organizationEvents(orgEvents = false)" class="mat-icon-button text-center"
          style="color:#1e90ff;margin-top: -15px;margin-right: 10px;" *ngIf="orgEvents" matTooltip="Disable">
          check_circle</mat-icon>
        <mat-icon (click)="organizationEvents(orgEvents = true)" class="mat-icon-button text-center"
          style="color:#1e90ff;margin-top: -15px;margin-right: 10px;" *ngIf="!orgEvents" matTooltip="Enable">
          panorama_fish_eye</mat-icon>
        <b>Organization Events</b>
      </mat-toolbar>

      <mat-divider *ngIf="(role.toLowerCase() == 'clerk' || role.toLowerCase() == 'judge')"></mat-divider>
      <br>
      <div class="select" *ngIf="(role.toLowerCase() == 'clerk' || role.toLowerCase() == 'judge')">
        <!-- <mat-form-field class="selectUser"> -->
        <!-- <mat-select placeholder="Add an user" class="selectUser" [(ngModel)]="addUserEvents" style="margin-top: 5px"
          (change)="addAssociatedUser(addUserEvents)">
          <mat-option *ngFor="let option of allUsers" [value]="option.id">{{option.first_name}}</mat-option>
        </mat-select> -->
        <user-selecter (select)="selectedList($event)" [isSave]="isSave"></user-selecter>
        <button mat-raised-button color="accent" style="float: right;margin-top: 10px;margin-bottom: 10px"
          (click)="addAssociatedUser(addUserEvents)" [disabled]="users.length < 1">ADD</button>
        <!-- </mat-form-field> -->
      </div>

      <div *ngIf="isSelectedUser.length > 0">
        <!-- <mat-divider></mat-divider> -->
        <mat-toolbar class="minimizeList">
          <span>Other Calendar</span>&nbsp;&nbsp;&nbsp;
          <button mat-icon-button class="mat-icon-button arrow" *ngIf="show === false" aria-label="open"
            (click)="show = true">
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
          <button mat-icon-button class="mat-icon-button arrow" *ngIf="show === true" aria-label="close"
            (click)="show = false">
            <mat-icon>keyboard_arrow_up</mat-icon>
          </button>
        </mat-toolbar>

        <mat-divider></mat-divider>

        <div *ngIf="show">
          <mat-list role="list" class="addedUsertable">
            <mat-list-item *ngFor="let user of isSelectedUser" style="background-color: 'user.color'">
              <mat-icon style="margin-top: -16px;margin-right: 10px;"
                (click)="enableUser(user.enabled,user.userId,user.color)" class="mat-icon-button text-center"
                [style.color]="user.color" *ngIf="user.enabled && !orgEvents" matTooltip="Disable">check_circle
              </mat-icon>
              <mat-icon style="margin-top: -16px;margin-right: 10px;"
                (click)="enableUser(user.enabled,user.userId,user.color)" class="mat-icon-button text-center"
                [style.color]="user.color" *ngIf="!user.enabled && !orgEvents" matTooltip="Enable">panorama_fish_eye
              </mat-icon>
              <mat-icon style="margin-top: -16px;margin-right: 10px;color: lightgray"
                (click)="enableUser(user.enabled,user.userId,user.color)" class="mat-icon-button text-center"
                *ngIf="orgEvents" matTooltip="Disabled">panorama_fish_eye</mat-icon>
              <span [matTooltip]="user.name">
                {{(user?.name?.length > 10) ? (user.name | slice:0:10) +'..':user.name }}
              </span>
              <div class="text-right">
                <mat-icon class="mat-icon-button more_vert" mat-icon-button [matMenuTriggerFor]="menu">more_vert
                </mat-icon>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="deleteUser(user.userId)" class="text-center"
                    mat-tooltip="Remove user.name">
                    Remove
                  </button>
                  <!-- <mat-divider></mat-divider> -->
                  <button class="mat-icon-button" *ngFor="let color of colorList"
                    (click)="updateAssociate(user.enabled,user.userId,color)">
                    <mat-icon [style.color]="color">lens</mat-icon>
                  </button>
                  <!-- <button class="mat-icon-button" (click)="getCustomColor()">
                  <mat-icon style="color: gray">add_color</mat-icon>
                </button> -->
                </mat-menu>
              </div>
            </mat-list-item>
          </mat-list>
        </div>
      </div>
    </div>
    <div class="contentCalender" eguardPerfectScrollbar *eguardIfOnDom
      [@animate]="{value:'*',params:{delay:'200ms',y:'50px'}}">
      <div [ngSwitch]="view">

        <mwl-calendar-month-view *ngSwitchCase="'month'" [viewDate]="viewDate" [events]="events" [refresh]="refresh"
          (dayClicked)="dayClicked($event.day)" (eventClicked)="editEvent('edit', $event)"
          (eventTimesChanged)="eventTimesChanged($event)" (beforeViewRender)="beforeMonthViewRender($event)">
        </mwl-calendar-month-view>

        <iq-calendar-week-hours-view *ngSwitchCase="'week'" [viewDate]="viewDate" [events]="events" [dayStartHour]="9"
          [dayEndHour]="18" (eventClicked)="editEvent('edit', $event)" (eventTimesChanged)="eventTimesChanged($event)"
          [refresh]="refresh">
        </iq-calendar-week-hours-view>

        <mwl-calendar-day-view *ngSwitchCase="'day'" [viewDate]="viewDate" [dayStartHour]="9" [dayEndHour]="18"
          (viewDateChange)="selectedDay = {date:$event}" [events]="events" [refresh]="refresh"
          (dayClicked)="dayClicked($event.day)" (eventClicked)="editEvent('edit', $event)"
          (eventTimesChanged)="eventTimesChanged($event)">
        </mwl-calendar-day-view>

      </div>
    </div>
  </div>
  <!-- / CONTENT -->
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/calendar/calendar-view/calendar.component.html